import { formatCount } from "./ui/format";

export const CountText = ({ num, variant = "caption" }) => {
    const numText = formatCount(num);
    return (
        // <Typography variant={variant}>{numText}</Typography>
        <span>{numText}</span>
    );
}